import React from "react";
import Seo from "../../shared/seo/Seo";
import { urls, copy, currentLang } from "../../shared/seo/links";
import ContactForm from "../../components/contactus/ContactForm";
import InfoSection from "../../components/contactus/InfoSection";
import { useTranslation } from "react-i18next";

export default function ContactUs() {
  const { t } = useTranslation();
  return (
    <>
      <Seo
        title={copy.page(currentLang(), "contact").title}
        description={copy.page(currentLang(), "contact").description}
        path={urls.sectionPath("contact", currentLang())}
        alternates={urls.alternates((l) => urls.sectionPath("contact", l))}
      />
      <section className="avc-page-hero">
        <div className="container avc-page-hero__inner">
          <span className="avc-eyebrow">
            <i className="far fa-envelope" aria-hidden="true"></i>
            {t("contact_eyebrow")}
          </span>
          <h1 className="avc-page-hero__title">{t("contact_title")}</h1>
          <p className="avc-page-hero__lead">
            {t("Contact_us_for_further_information_or_assistance")}
          </p>
        </div>
      </section>
      <div className="avc-page">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <ContactForm />
            </div>
            <aside className="col-lg-4">
              <InfoSection />
            </aside>
          </div>
        </div>
      </div>
    </>
  );
}
